import React from 'react';

/**
 * This file is simply to allow the iframe from docusign to reload on the same domain,
 * this allows us to listen to an event and fire it off in another (UserLogin) component
 */

export default class UserAgreement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            status: null
        };
    }
    
    componentDidMount() {
        let status = null;
        try {
            status = location.search && decodeURIComponent(location.search.split('=')[1]);
            this.setState({
                status: status
            });
            if(window.parent) {
                window.parent.postMessage(status,"*");  //  `*` on any domain
            }
        } catch(e) {}
    }

    render() {
        return (
            <div>
                <style dangerouslySetInnerHTML={{__html: `body { display: none }`}} />
                Agreement response: {this.state.status}
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserAgreement/index.js